import React from "react";

const HeaderContent = ({data, renderItem}) => {
    return renderItem(data);
}
 
export default HeaderContent;